import { formatRupeeLabel } from '../../../../../display-values/lumpsumPlanAmount'
import type { LumpsumAllocationUnderReviewRecommendation } from '../../../../api/allocation.types'
import {
  PlansFundCard,
  type PlanFundCardInsight
} from '../../../lumpsum-ui-components/PlansFundCard'
import { buildAllocationInsightsFromTags } from '../allocationInsightTags'

type AllocationUnderReviewFundCardProps = {
  recommendation: LumpsumAllocationUnderReviewRecommendation
  categoryName: string
  showBottomDivider?: boolean
}

export function AllocationUnderReviewFundCard({
  recommendation,
  categoryName,
  showBottomDivider = true
}: AllocationUnderReviewFundCardProps) {
  const isin = recommendation?.isin ?? ''
  const currentValue = recommendation?.currentValue ?? 0
  const insights = buildAllocationUnderReviewInsights(recommendation, categoryName)

  return (
    <PlansFundCard
      fund={{
        isin,
        logoUrl: recommendation?.mfLogoUrl ?? '',
        title: recommendation?.fundName ?? '',
        fundNature: recommendation?.fundNature ?? '',
        category: recommendation?.fundCategory ?? '',
        purchaseMode: recommendation?.purchaseMode ?? ''
      }}
      topRight={
        <div className="text-right shrink-0 -mt-[1px] text-[13px] font-[500] text-[#232323]">
          {formatRupeeLabel({ rawAmount: currentValue })}
        </div>
      }
      status={{
        rank: recommendation?.powerRank ?? 0,
        rating: recommendation?.powerRating ?? ''
      }}
      recommendationStatus={recommendation?.recommendationStatus}
      recommendationStatusDisplayText={recommendation?.recommendationStatusDisplayText}
      insights={insights}
      supportingText={recommendation?.underReviewReasonText ?? ''}
      showBottomDivider={showBottomDivider}
    />
  )
}

export function buildAllocationUnderReviewInsights(
  recommendation: LumpsumAllocationUnderReviewRecommendation,
  categoryName: string
): PlanFundCardInsight[] {
  return buildAllocationInsightsFromTags({
    tags: recommendation?.tags,
    isin: recommendation?.isin ?? '',
    categoryName
  })
}
